export const LOGIN_TYPE_MANUAL = 0;
export const LOGIN_TYPE_LDAP = 1;
export const LOGIN_TYPE_AD = 2;
export const LOGIN_TYPE_HASHED = 3;
export const LOGIN_TYPE_AUTH = 4;
export const LOGIN_TYPE_AUTH_WITH_GROUPS = 5;

export const LOGIN_STATUS = {
    OK: 0,
    ERROR: 1,
    MFA_REGISTRATION: 2, // The user needs to register for MFA. Show a QR code, register and submit a code.
    MFA_CODE: 3 // The user needs to submit their MFA code.
}
